export class RouteApiRoutes {
    public static IMPORT_GTFS = 'import/gtfs';
    public static IMPORT_EXCEL = 'import/excel/async';
    public static DOWNLOAD_GTFS = 'download/gtfs';
    public static GET_TERRAINS = 'terrains';
    public static GET_SAES = 'saes';
    public static DRAFT_TERRAIN = 'draft-terrain';
    public static APPLY_DRAFT_TERRAIN = 'apply-draft-terrain';
    public static SCHEDULED_CHANGE = 'scheduled-change';
    public static SCHEDULE_TERRAIN_UPDATE = 'schedule-terrain-update';
}